import { render, staticRenderFns } from "./InstanceUrl.vue?vue&type=template&id=5dea98c4"
import script from "./InstanceUrl.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstanceUrl.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports